export enum RoleType {
  ADMINISTRATOR,
  EMPLOYEE
}

export enum RolesLabelType {
  ADMINISTRATOR = 'Administrator',
  EMPLOYEE = 'Employee'
}
